'use client'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { Progress } from '@/components/ui/progress'
import type { StoryboardSegment } from '../types'

export interface SegmentStatusBannerProps {
  segment: StoryboardSegment | null;
}

const SegmentStatusBanner: React.FC<SegmentStatusBannerProps> = ({ segment }) => {
  if (!segment) {
    return null;
  }
  const status = segment.status;
  const hasPreview = Boolean(segment.previewUrl);
  const progressValue =
    typeof segment.progress === 'number' && Number.isFinite(segment.progress)
      ? Math.max(0, Math.min(100, Math.round(segment.progress)))
      : undefined;

  if (status === 'queued' || status === 'generating') {
    const description =
      status === 'queued'
        ? '生成任务已提交，正在等待排队开始。'
        : '视频生成中，请耐心等待片刻。'
    return (
      <Alert>
        <AlertDescription className="space-y-1.5">
          <div className="text-sm">{description}</div>
          {progressValue !== undefined ? (
            <div className="space-y-1">
              <Progress value={progressValue} />
              <div className="text-[11px] text-muted-foreground">已完成 {progressValue}%</div>
            </div>
          ) : null}
        </AlertDescription>
      </Alert>
    )
  }

  if (status === 'failed') {
    return (
      <Alert variant="destructive">
        <AlertDescription className="text-sm">
          生成任务失败，请稍后重试或前往「任务记录」查看详情。
        </AlertDescription>
      </Alert>
    )
  }

  if (status === 'success' && hasPreview) {
    return (
      <Alert>
        <AlertDescription className="text-sm">
          最新视频已生成，并自动更新至左侧预览。
        </AlertDescription>
      </Alert>
    )
  }

  return null
};

export default SegmentStatusBanner;
